import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SPECIFIED_POOLS_ACTION_TYPE } from '../actions/specifiedPools.actions';

const initialState = {
  list: [],
};

const specifiedPoolsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case SPECIFIED_POOLS_ACTION_TYPE.GET_SPECIFIED_POOLS:
        draft.list = Array.isArray(payload) ? payload : (payload?.items ?? []);
        break;

      case SPECIFIED_POOLS_ACTION_TYPE.CREATE_SPECIFIED_POOL:
        draft.list = [payload, ...draft.list];
        break;

      case SPECIFIED_POOLS_ACTION_TYPE.UPDATE_SPECIFIED_POOL:
        draft.list = draft.list.map(pool => (pool.id === payload.id ? payload : pool));
        break;

      case SPECIFIED_POOLS_ACTION_TYPE.CLONE_SPECIFIED_POOL:
        draft.list = [payload, ...draft.list];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default specifiedPoolsReducer;
